import { t } from "@/lib/strings";

export const Header = ({ onCta }) => (
  <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b-2 border-obsidian">
    <div className="av-container flex items-center justify-between h-16">
      <a href="/" className="flex items-center gap-2" data-testid="logo">
        <img src="/dev4u-mark.svg" alt="dev4u" className="h-8 w-8" />
        <span className="font-display text-xl text-obsidian" dir="ltr">
          dev<span className="text-conversion">4</span>u
        </span>
      </a>
      <button onClick={onCta} className="av-btn !px-5 !py-2.5 text-sm" data-testid="header-cta">
        {t("header.cta")}
      </button>
    </div>
  </header>
);

export default Header;
